import { apiClient } from '../axiosInstance';
import type { EquipmentService } from './interfaces/EquipmentService';
import {
  adaptEquipment,
  type Equipment,
  type EquipmentWire,
} from './adapters/equipment';

export const equipmentService: EquipmentService = {
  // Phase 6.2 (PROF-04) — fetch the customer's equipment via the server-minted
  // HATEOAS link `user.links.fetch_equipment`. The URL is GET'd VERBATIM (same
  // convention as deletePaymentMethod(deleteUrl)); the service NEVER
  // reconstructs `/v3/customers/:id/equipment` (Pitfall 2 / threat
  // T-06.2-02). The wire array is reshaped by adaptEquipment. Mirrors
  // InvoiceService.getPaymentMethods (fetch wire array → hand to adapter).
  async getEquipment(fetchUrl: string): Promise<Equipment[]> {
    const { data } = await apiClient.get<EquipmentWire[]>(fetchUrl);
    return adaptEquipment(data);
  },
};
